import type { AuthStatusBreakdown } from '../../lib/api.js';
import { formatNumber } from '../../lib/formatters.js';

/**
 * @graph-stack ux-mirror
 * @graph-domain UX
 * @graph-business エラー分析の認証ステータス別内訳バー。logged_in / anonymous の比率を太いスタックバー + 凡例で描画する。
 * @graph-connects formatNumber [calls] 数値フォーマット
 */
export function AuthStatusBar({
  data,
  t,
}: {
  data: AuthStatusBreakdown[];
  t: (key: string) => string;
}) {
  const loggedIn = data.find((d) => d.authStatus === 'logged_in');
  const anonymous = data.find((d) => d.authStatus === 'anonymous');
  const liCount = loggedIn?.eventCount ?? 0;
  const anCount = anonymous?.eventCount ?? 0;
  const liSessions = loggedIn?.uniqueSessions ?? 0;
  const anSessions = anonymous?.uniqueSessions ?? 0;
  const total = liCount + anCount || 1;
  const liPct = (liCount / total) * 100;
  const anPct = (anCount / total) * 100;

  return (
    <div className="space-y-3">
      <div className="flex h-6 rounded-md overflow-hidden">
        {liCount > 0 && (
          <div
            className="flex items-center justify-center text-[10px] font-medium text-white"
            style={{ width: `${String(liPct)}%`, background: 'var(--chart-1)' }}
          >
            {liPct >= 10 ? `${liPct.toFixed(0)}%` : ''}
          </div>
        )}
        {anCount > 0 && (
          <div
            className="flex items-center justify-center text-[10px] font-medium text-white"
            style={{ width: `${String(anPct)}%`, background: 'var(--chart-3)' }}
          >
            {anPct >= 10 ? `${anPct.toFixed(0)}%` : ''}
          </div>
        )}
      </div>
      <div className="flex gap-6 text-xs">
        <div className="flex items-center gap-2">
          <span
            className="inline-block w-3 h-3 rounded-sm"
            style={{ background: 'var(--chart-1)' }}
          />
          <span className="text-[var(--color-text-secondary)]">
            {t('errors.loggedIn')}: {formatNumber(liCount)} ({liPct.toFixed(1)}%) —{' '}
            {formatNumber(liSessions)} {t('errors.uniqueSessions')}
          </span>
        </div>
        <div className="flex items-center gap-2">
          <span
            className="inline-block w-3 h-3 rounded-sm"
            style={{ background: 'var(--chart-3)' }}
          />
          <span className="text-[var(--color-text-secondary)]">
            {t('errors.anonymous')}: {formatNumber(anCount)} ({anPct.toFixed(1)}%) —{' '}
            {formatNumber(anSessions)} {t('errors.uniqueSessions')}
          </span>
        </div>
      </div>
    </div>
  );
}
